import { useMemo } from 'react';
import Card from '../../../../Components/Dashboard/Card';
import { CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { cssToPacePer100 } from '../../../../Utils/format/pace';
import { buildWeeklyLoad } from './weeklyLoadModel';
import WeeklyLoadChart from './WeeklyLoadChart';
import styles from '../dashboardCards.module.css';

const TITLE = 'Weekly load';
const one = v => v.toFixed(1);

const WeeklyLoadCard = ({ workouts, now, css }) => {
    const { status, data, error, reload } = workouts;
    const view = useMemo(() => (data ? buildWeeklyLoad(data, now) : null), [data, now]);

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (view) {
        const { totals } = view;
        body = (
            <>
                <div className={styles.statline}>
                    <div>
                        <small>Distance</small>
                        <b>{one(totals.completedKm)}</b>
                        <span className={styles.muted}>{`/ ${one(totals.plannedKm)} km`}</span>
                    </div>
                    <div>
                        <small>Sessions</small>
                        <b>{totals.completedSessions}</b>
                        <span className={styles.muted}>{`/ ${totals.sessions}`}</span>
                    </div>
                    <div>
                        <small>CSS /100 m</small>
                        <b>{css ? cssToPacePer100(css) : 'not set'}</b>
                    </div>
                </div>
                <WeeklyLoadChart days={view.days} label={view.ariaLabel} />
                <div className={styles.legend} style={{ marginTop: 6 }}>
                    <span><i style={{ background: 'var(--blue-700)' }} />Completed</span>
                    <span><i style={{ background: '#fff', boxShadow: 'inset 0 0 0 1.5px var(--blue-500)' }} />Planned</span>
                </div>
            </>
        );
    }

    return (
        <Card id="wl" module="athlete-week" title={TITLE} sub={view ? view.rangeLabel : undefined} busy={status === 'loading'}>
            {body}
        </Card>
    );
};

export default WeeklyLoadCard;
